export default {
    deckOrder: "Sort by Decklist Order",
    nameAZ: "Sort By Name A-Z",
    nameZA: "Sort By Name Z-A",
    cardType: "Sort By Card Type",
    price: "Sort By Price",
    empty: "Sort By None Available",
}
